<template>
  <div class="participant-wrap" v-loading="loading">
    <div class="par-content">
      <div class="par-content-left">
        <div class="search-content">
          <div class="top-search">
            <el-input prefix-icon="icon iconfont iconicon_search1" v-model="searchInput" size="mini" placeholder="搜索成员" clearable></el-input>
          </div>
          <div class="tree-box">
            <el-tree :props="{ multiple: true, emitPath: false, value: 'uid', label: 'realname', children: 'children' }" :data="taskMemberlist" node-key="uid" :indent="30" :default-checked-keys="selectItems" show-checkbox :filter-node-method="filterNode" empty-text="暂无搜索结果" ref="tree" @check-change="onChange2">
              <template slot-scope="{ node, data }">
                <div class="participant-tree-node">
                  <Myavatar v-if="data.uid" width="30px" height="30px" :imgUrl="data.user_avatar" :userName="data.realname"></Myavatar>
                  <span>{{ data.realname }}</span>
                </div>
              </template>
            </el-tree>
          </div>
        </div>
      </div>
      <div class="par-content-right" v-loading="rightLoading">
        <div class="top-filter">
          <p>已选：{{ saveMember.length }}个成员</p>
          <span class="text-red" @click="clearPanel" :class="{ disabled: saveMember.length === 0 }"> 清空 </span>
        </div>
        <div class="checked-list">
          <div class="checked-item" v-for="item in saveMember" :key="item.uid">
            <div class="flex">
              <Myavatar width="30px" height="30px" :imgUrl="item.user_avatar" :userName="item.realname"></Myavatar>
              {{ item.realname }}
            </div>
            <span class="del text-red" @click="removeChecked(item.uid)">移除</span>
          </div>
          <nothing v-if="saveMember.length === 0" :config="{ tip: '暂无成员' }" width="88"></nothing>
        </div>
      </div>
    </div>
    <div class="par-bottom">
      <div class="par-left-btns"></div>
      <div class="par-bottom-btns">
        <span class="cancel text-btn-active" @click="close" style="margin-right: 30px">取消</span>
        <wf-button type="primary" @click="confirm">保存</wf-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: '',
  props: {
    membersUidArr: {
      // 成员id组成的数组
      type: Array,
      default: () => []
    },
    showUser: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectItems: [], // 选择项
      saveMember: [],
      loading: false, // 加载动画
      searchInput: '',
      localList: [],
      selectData: [],
      tpData: [],
      rightLoading: false,
      taskMemberlist: [],
      changeList: [] // 搜索时操作的列表
    }
  },
  computed: {
    ...mapState('department/department', {
      allDepartmentUser: (state) => state.allDepartmentUser
    })
  },
  watch: {
    // selectedData: {
    //   handler: function (value) {
    //     this.selectItems = JSON.parse(JSON.stringify(this.selectedData || []))
    //   },
    //   deep: true,
    //   immediate: true
    // }
    searchInput(val) {
      this.$refs.tree.filter(val)
      if (!val) {
        this.$nextTick(() => {
          const arr = this.saveMember.map((item) => item.uid)
          this.$refs.tree.setCheckedKeys(arr, true)
        })
      }
    }
  },
  created() {
    this.init()
    // setTimeout(() => {
    //   this.$refs.tree.setCheckedKeys([327, 323, 321], true)
    // }, 2000)
  },
  methods: {
    ...mapActions('department/department', ['getAllDepartmentUser']),
    // 递归遍历数据
    getTreeData(data) {
      // 先将data的部门信息添加到数组中
      // const _len = this.getTreeNum(data)
      // const _name = `${data.name} ${_len ? `（${_len}）` : ''}`
      const _name = data.name
      let obj = {
        realname: _name,
        children: []
      }
      if (data?.user?.length) {
        // 有员工，添加员工数据
        data.user.forEach((item) => {
          if (this.showUser) {
            if (~this.membersUidArr.indexOf(item.uid)) {
              this.saveMember.push({
                value: item.uid,
                uid: item.uid,
                label: item.realname,
                realname: item.realname,
                user_avatar: item.user_avatar
              })
              this.selectItems.push(item.uid)
            }
            obj.children.push({
              value: item.uid,
              uid: item.uid,
              label: item.realname,
              realname: item.realname,
              user_avatar: item.user_avatar
            })
          } else {
            if (!~this.membersUidArr.indexOf(item.uid)) {
              obj.children.push({
                value: item.uid,
                uid: item.uid,
                label: item.realname,
                realname: item.realname,
                user_avatar: item.user_avatar
              })
            }
          }
        })
      }
      // 判断是否有子部门，有则递归
      if (data?.children?.length) {
        data.children.forEach((item) => {
          obj.children.push(this.getTreeData(item))
        })
      }
      return obj
    },
    // 递归获取员工数量
    getTreeNum(data) {
      let _num = 0
      if (data?.user?.length) {
        data.user.forEach((item) => {
          if (!~this.membersUidArr.indexOf(item.uid)) {
            _num += 1
          }
        })
      }
      if (data?.children?.length) {
        data.children.forEach((item) => {
          _num += this.getTreeNum(item)
        })
      }
      return _num
    },
    async init() {
      this.loading = true
      if (!this.allDepartmentUser?.length) {
        await this.getAllDepartmentUser()
      }
      let arr = []
      if (this.allDepartmentUser?.length) {
        const _list = this.allDepartmentUser
        for (let i = 0, len = _list.length; i < len; i++) {
          arr.push(this.getTreeData(_list[i]))
        }
      }
      this.taskMemberlist = JSON.parse(JSON.stringify(arr))
      this.loading = false
    },
    filterNode(value, data) {
      if (!value) return true
      return data.realname.indexOf(value) !== -1
    },
    // 移除选中的选项
    removeChecked(uid) {
      let flag = this.saveMember.findIndex((res) => res.uid == uid)
      this.saveMember.splice(flag, 1)
      this.$refs.tree.setChecked(uid, false)
      // this.$nextTick(() => {
      //   this.onChange()
      // })
    },
    // 关闭
    close() {
      this.$emit('close')
    },
    confirm() {
      console.log('--------ggg--------')
      const arr = this.saveMember.map((item) => {
        return item.uid
      })
      this.$emit('confirm', arr, this.saveMember)
    },
    clearPanel() {
      this.saveMember = []
      this.$refs.tree.setCheckedKeys([])
    },
    // onChange(val) {
    //   // console.log(val, 111)
    //   const list = JSON.parse(JSON.stringify(this.$refs.tree.getCheckedNodes(true, false)))
    //   let _chosMember = []
    //   if (this.searchInput) {
    //     // 搜索中
    //     _chosMember = list.filter((item) => item.uid && ~item.realname.indexOf(this.searchInput))
    //     this.saveMember.push(..._chosMember)
    //   } else {
    //     _chosMember = list.filter((item) => item.uid)
    //     this.saveMember = _chosMember
    //   }
    //   // console.log('--------------asd----------', this.lockUid, this.value, this.selectItems, this.saveMember)
    // }
    onChange(data, checked, indeterminate) {
      // if (data?.children?.length) {
      //   // 遍历所有子节点，检查是否都符合筛选条件
      //   const allChildrenPassFilter = data.children.every((child) => {
      //     // 这里需要确保filterNode方法能够访问到，或者将筛选逻辑提取到可复用的地方
      //     return this.filterNode('', child) // 第一个参数传空字符串是因为我们只关心是否通过当前的筛选逻辑
      //   })

      //   // 如果不是所有子节点都通过筛选，且当前节点是选中状态，则需要取消选中
      //   if (!allChildrenPassFilter && checked) {
      //     this.$refs.tree.setCheckedKeys(data.uid, false, true) // 第三个参数为true表示不影响子节点
      //   }
      // }

      let _chosMember = []
      // const list = JSON.parse(JSON.stringify(this.$refs.tree.getCheckedNodes(true, false)))
      const list = JSON.parse(JSON.stringify(this.$refs.tree.getCheckedNodes(true, false))).filter((item) => item.uid)
      if (this.searchInput) {
        // 搜索中
        console.log(data, checked, 1111)
        // if (!list?.length) {
        //   // 选空时，将已选的列表筛选出跟关键字相关并清除
        //   this.saveMember = this.saveMember.filter((item) => {
        //     return !~item.realname.indexOf(this.searchInput)
        //   })
        // } else {
        _chosMember = list.filter((item) => item.uid && ~item.realname.indexOf(this.searchInput))
        this.saveMember.push(..._chosMember)
        // }

        // this.changeList = []
        // this.getChangeList(data)
        // if (checked) {
        //   // 选中
        //   this.saveMember.push(...this.changeList)
        //   // 去重
        //   this.saveMember = this.saveMember.filter((item, index, arr) => {
        //     return arr.findIndex((it) => it.uid === item.uid) === index
        //   })
        // } else {
        //   // 取消选中
        //   this.saveMember = this.saveMember.filter((item) => {
        //     return !this.changeList.find((it) => it.uid === item.uid)
        //   })
        // }
      } else {
        _chosMember = list.filter((item) => item.uid)
        this.saveMember = _chosMember
      }
    },
    onChange2(data, checked, val3) {
      // console.log(data, checked, val3, 111)

      if (this.searchInput) {
        if (!data?.uid) return
        // 搜索中
        if (!~data.realname.indexOf(this.searchInput)) return
        const _item = this.saveMember.find((item) => item.uid === data.uid)
        if (checked) {
          // 选中
          if (_item) return
          this.saveMember.push(data)
        } else {
          // 取消选中
          if (_item) {
            this.saveMember = this.saveMember.filter((item) => item.uid !== data.uid)
          }
        }
      } else {
        const list = JSON.parse(JSON.stringify(this.$refs.tree.getCheckedNodes(true, false))).filter((item) => item.uid)
        this.saveMember = list
      }
    },
    getChangeList(data) {
      if (data?.children?.length) {
        // 有子项，递归寻找
        data.children.forEach((item) => {
          if (item?.uid) {
            // 员工
            this.changeList.push(data)
          } else if (item?.children?.length) {
            // 部门
            this.getChangeList(item)
          }
        })
      }

      if (data?.uid) {
        // 员工
        this.changeList.push(data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';
::v-deep {
  .el-cascader-node.is-active {
    color: initial;
  }
  .el-cascader-node.in-active-path {
    color: initial;
  }
}
.participant-wrap {
  // padding: 10px;
  height: 553px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  .tree-box {
    height: 0;
    flex: 1;
    overflow: auto;
    padding: 16px 24px;
  }
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  /deep/ {
    .el-tree {
      .el-tree-node__content > .el-tree-node__expand-icon {
        padding-left: 8px;
        color: #a6a6a6;
        margin-right: 8px;
      }
    }
    .participant-tree-node {
      font-size: 14px;
      display: flex;
      align-items: center;
      .avatar-box {
        margin-right: 8px;
      }
    }
    .el-checkbox {
      margin: 0;
      padding: 11px 8px 11px 0;
    }
    // .el-tree .el-tree-node__content > .custom-tree-node {
    //   padding-left: 28px !important;
    // }
  }
  .par-top {
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    border-bottom: 1px solid #e6e6e6;
    .close {
      cursor: pointer;
    }
  }
  .par-content-left {
    // margin-right: 20px;
  }
  .par-content {
    display: flex;
    justify-content: space-between;
    // padding: 20px 0;
    border-bottom: 1px solid #e6e6e6;
    height: 0;
    flex: 1;
  }
  .par-content-right {
    border-left: 1px solid #e6e6e6;
    display: flex;
    flex-direction: column;
    .top-filter {
      height: 54px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px;
      color: rgba(32, 32, 32, 0.4);
      flex-shrink: 0;
      .disabled {
        cursor: not-allowed;
        color: rgba(32, 32, 32, 0.4);
        &:hover {
          color: rgba(32, 32, 32, 0.4);
        }
      }
    }
  }
  .search-content {
    width: 360px;
    height: 100%;
    .all-footer {
      display: flex;
      align-items: center;
      margin: 16px 0 0;
      padding-left: 8px;
      box-sizing: border-box;
      font-size: 14px;
      @include fontColorOpacity(0.6);
      cursor: pointer;
      height: 20px;
      line-height: 20px;
      text-align: center;
      i {
        font-size: 12px;
        color: #a6a6a6;
        margin-right: 14px;
      }
    }
    .group-box {
      padding-top: 10px;
      overflow: auto;
    }
    .top-search {
      height: 54px;
      border-bottom: 1px solid rgba(32, 32, 32, 0.08);
      padding: 0 16px;
      flex-shrink: 0;
      /deep/ {
        .el-input__icon {
          line-height: 54px;
          font-size: 14px;
        }
        .el-input {
          height: 100%;
        }
        .el-input__inner {
          height: 100%;
          border: 0 none !important;
          &:hover {
            border: 0 none !important;
          }
        }
        .el-input__prefix i {
          color: rgba(32, 32, 32, 0.8);
        }
      }
    }
  }

  .checked-list {
    width: 362px;
    overflow: auto;
    padding: 0 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    position: relative;
    height: 0;
    flex: 1;
    .checked-item {
      cursor: pointer;
      padding: 0 16px;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .del {
        display: none;
      }
      .flex {
        display: flex;
        align-items: center;
      }
      .avatar-box {
        margin-right: 15px;
      }
    }
    .checked-item:hover {
      background-color: rgba(32, 32, 32, 0.04);
    }
    .checked-item:hover > .del {
      display: inline-block;
    }
  }
  .search-content {
    display: flex;
    flex-direction: column;
  }
  .colleagues-list {
    padding: 5px;
    display: block;
    margin-left: 0;
  }
  .search-content .colleagues-list .el-checkbox__label {
    display: flex;
  }
  .par-bottom {
    display: flex;
    width: 100%;
    height: 64px;
    padding: 0 24px;
    box-sizing: border-box;
    justify-content: space-between;
  }
  .check-info {
    display: flex;
    align-items: center;
  }
  .check-info .avatar-box {
    margin-right: 20px;
  }
  .el-cascader-panel {
    margin-top: 10px;
    height: 257px;
  }
  .no-list {
    margin-top: 10px;
  }
  .is-disabled {
    opacity: 0.4;
    * {
      cursor: not-allowed;
    }
  }
}
</style>
